(function() {
  "use strict";

  angular.module("marketPlace.profile").controller("AssociationsController", associationsController);

  associationsController.$inject = ["$filter", "$log", "$scope", "$q", "_", "toastr", "user", "Association"];

  function associationsController($filter, $log, $scope, $q, _, toastr, user, Association) {
    const vm = this;

    vm.saving = false;
    vm.errors = {};

    // pre-resolved dependencies
    vm.user = user;
    vm.associations = null;
    vm.sponsor = null;

    // functions
    vm.save = save;
    vm.addSponsor = addSponsor;
    vm.removeSponsor = removeSponsor;
    vm.tagTransform = tagTransform;

    // forms
    vm.referenceForm = {};
    vm.referenceForm.form = {};

    activate();

    function activate() {
      getAssociations().then(function(associations) {
        vm.associations = associations;
        updateLoading();
      });
    }

    function updateLoading() {
      vm.isLoaded = vm.associations !== null;
    }

    function getAssociations() {
      if (vm.user.categories.length > 0) {
        $log.debug("User has categories");
        const deferred = $q.defer(),
          categoryNames = [];

        vm.user.categories.forEach(function(category) {
          categoryNames.push(category.name);
        });

        Association.associations({ category: categoryNames.join() }, function(initialResults) {
          if (initialResults.length < 6) {
            // get more associations
            Association.associations(function(allResults) {
              deferred.resolve(_.union(initialResults, allResults));
            });
          } else {
            deferred.resolve(initialResults);
          }
        });
        return deferred.promise;
      } else {
        $log.debug("User has no categories");
        return Association.associations().$promise;
      }
    }

    function save(form) {
      $log.debug("saving associations");

      $scope.$broadcast("show-errors-check-validity");

      if (form.$invalid) {
        $log.debug("form is invalid");
        return;
      } else {
        vm.errors = {};
      }

      vm.saving = true;
      vm.user.associations = _.compact(vm.user.associations);
      vm.user
        .$patch(
          ["associations"],
          function() {
            $scope.$broadcast("show-errors-reset");
            toastr.success("Associations updated");
            form.$setPristine();
          },
          function(resp) {
            $log.debug("Error saving tab");

            if (resp.data && resp.status !== 500) {
              angular.forEach(resp.data, function(errors, field) {
                $log.debug(field + " : " + errors);
                try {
                  form[field].$setValidity("server", false);
                  if (angular.isObject(errors)) {
                    angular.forEach(errors, function(subErrors, field) {
                      vm.errors[field] = subErrors.join(", ");
                    });
                  } else {
                    vm.errors[field] = errors.join(", ");
                  }
                } catch (e) {
                  $log.error(resp.status + ": " + resp.statusText);
                  if (angular.isArray(errors)) {
                    errors = errors.join(", ");
                  }
                  vm.errors.non_field_errors = errors;
                }
              });
            } else {
              if (vm.user.associations.length > 0 && !vm.user.associations[vm.user.associations.length - 1].name) {
                vm.user.associations.pop();
              }

              if (vm.user.clubs.length > 0 && !vm.user.clubs[vm.user.clubs.length - 1].name) {
                vm.user.clubs.pop();
              }

              $log.error(resp.status + ": " + resp.statusText);
              vm.errors.non_field_errors =
                "Sorry there was a problem saving your clubs and references, please try again";
            }
            $scope.$broadcast("show-errors-check-validity");
          }
        )
        .finally(function() {
          vm.saving = false;
        });
    }

    function addSponsor() {
      vm.user.associations.push(angular.copy(vm.sponsor));
      vm.sponsor = null;
    }

    function removeSponsor(index) {
      vm.user.associations.splice(index, 1);
    }

    function tagTransform(newTag) {
      return {
        name: newTag
      };
    }
  }
})();
